import Perfil from '@/services/Perfil'
import axios from '@/utils/axios'
const actions = {
  async getPerfil (context: any) {
    try {
      const perfil = new Perfil(axios)
      const data = await perfil.listar()
      if (data != null && JSON.stringify(data) !== '{}') {
        const usuarioLogueado = data.usuario_logueado
        if (usuarioLogueado) {
          context.commit('datosAuth', usuarioLogueado)
        }
      }
    } catch (error) {
      throw new Error(JSON.stringify(error))
    }
  }

}

export default actions
